import { PostAuthor } from "@radarly/models/posts";

export interface BlacklistRepository {
  createBlacklistAuthor(project: number, author: PostAuthor): Promise<void>;
}

export const BlacklistRepositoryUID = Symbol("Radarly/BlacklistRepository");
